import React from 'react';

const Close = ({ className, ...props }) => (
  <i className={['material-icons', className].join(' ')} {...props}>
    close
  </i>
);
export default Close;
